import $ from "jquery"
import {BillingSummaryReportInfo} from 'constants'
import {ReportGroupingLevel} from '../../../constants'
import BSHtmlAllTasksStrategy from './BSHtmlAllTasksStrategy'
import BSHtmlBillableBTTimeStrategy from './BSHtmlBillableBTTimeStrategy'
import BSHtmlNonBillableBTStrategy from './BSHtmlNonBillableBTStrategy'
import BSHtmlBillableBTMoneyStrategy from './BSHtmlBillableBTMoneyStrategy'
import BSHtmlBTWithAmountStrategy from './BSHtmlBTWithAmountStrategy'
import BSHtmlBillableTasksStrategy from './BSHtmlBillableTasksStrategy'
import BSHtmlNonBillableTasksStrategy from './BSHtmlNonBillableTasksStrategy'
import BSHtmlAvrgRatesStrategy from './BSHtmlAvrgRatesStrategy'
import BSHtmlBillableAmountStrategy from './BSHtmlBillableAmountStrategy'
import BSHtmlBillableTimeAndAmountStrategy from './BSHtmlBillableTimeAndAmountStrategy'
import BSHtmlNullTasksStrategy from './BSHtmlNullTasksStrategy'
import HTMLCompositeColumnsStrategy from './HTMLCompositeColumnsStrategy'
import BillingSummaryHTMLPreviewHeaderSection from './BillingSummaryHTMLPreviewHeaderSection'
import BillingSummaryHTMLPreviewGroupingSection from './BillingSummaryHTMLPreviewGroupingSection'

export default function BillingSummaryHTMLPreviewGenerator() {}

BillingSummaryHTMLPreviewGenerator.prototype.init = function()
{
    return this;
};

BillingSummaryHTMLPreviewGenerator.prototype.generatePreviewTable = function( reportParameters )
{
    var table = document.createElement( "table" );
    table.className = "reportHtmlPreviewTable billingSummary";
    var tBody = document.createElement( "tbody" );
    table.appendChild( tBody );

    var groupingLevelsArray = [
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel
    ];

    var filteredLevelsArray = ReportPreviewUtils.filterNotEmptyLevels(groupingLevelsArray);
    var reportInfo = reportParameters.reportInfo;
    var timeFormat = reportParameters.timeFormat;
    
    var columnsStrategy = this.createColumnsStrategy(reportInfo, timeFormat);

    var headerSection = new BillingSummaryHTMLPreviewHeaderSection().init(filteredLevelsArray, columnsStrategy);
    const groupingSection = new BillingSummaryHTMLPreviewGroupingSection().init(
        filteredLevelsArray,
        reportParameters.thirdGroupingLevel !== ReportGroupingLevel.NONE,
        columnsStrategy,
        reportParameters.timeFormat,
        reportParameters.reportAuthorizationInfo,
    )

    if ( reportInfo == BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS ||
         reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES )
        $(tBody).addClass("narrow");
    
    headerSection.addRows( tBody );
    groupingSection.addRows( tBody );

    return table;
};

BillingSummaryHTMLPreviewGenerator.prototype.createColumnsStrategy = function ( reportInfo, timeformat )
{
    var columns, firstBT, secondBT;
    switch ( reportInfo ) {
        case BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS:
            firstBT = new BSHtmlBillableBTTimeStrategy().init(timeformat);
            columns = [new BSHtmlBillableTasksStrategy().init(timeformat), firstBT, firstBT];
            break;

        case BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS:
            firstBT = new BSHtmlNonBillableBTStrategy().init(timeformat);
            columns = [new BSHtmlNonBillableTasksStrategy().init(timeformat), firstBT, firstBT];
            break;

        case BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS:
            firstBT = new BSHtmlBillableBTTimeStrategy().init(timeformat);
            secondBT = new BSHtmlNonBillableBTStrategy().init(timeformat);
            columns = [new BSHtmlAllTasksStrategy().init(timeformat), firstBT, secondBT];
            break;

        case BillingSummaryReportInfo.BILLABLE_AMOUNT:
            firstBT = new BSHtmlBillableBTMoneyStrategy().init(timeformat);
            columns = [new BSHtmlBillableAmountStrategy().init(timeformat), firstBT, firstBT];
            break;
        
        case BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT:
            firstBT = new BSHtmlBTWithAmountStrategy().init(timeformat);
            columns = [new BSHtmlBillableTasksStrategy().init(timeformat), new BSHtmlBillableTimeAndAmountStrategy().init(timeformat), firstBT, firstBT];
            break;
        
        case BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES:
            firstBT = new BSHtmlBTWithAmountStrategy().init(timeformat);
            columns = [new BSHtmlBillableTasksStrategy().init(timeformat), new BSHtmlAvrgRatesStrategy().init(timeformat),
                       new BSHtmlBillableTimeAndAmountStrategy().init(timeformat), firstBT, firstBT];
            break;
        
        default: return new BSHtmlNullTasksStrategy().init(timeformat);
    }
    
    return new HTMLCompositeColumnsStrategy().init( columns );   //[timeStrategy, moneyStrategy, btStrategy]
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BillingSummaryHTMLPreviewGenerator.js